import React, { useState, useEffect } from 'react'
import SidebarProposal from '../../../layouts/sidebarProposal/SidebarProposal'
import ErrorWidget from '../../../widgets/errorWidget/ErrorWidget'
import PanalLoadingTemplate from '../../../widgets/loadingTemplate/panalLoadingTemplate/PanalLoadingTemplate'
import ContentHeader from '../../../components/ContentHeader/ContentHeader'
import ReSendFilesContractWidget from '../../../widgets/attachfiles/ReSendFilesContractWidget'
import { startLoading, doneLoading } from '../../../utils/loading'
import { getContractChangeFormPage } from '../../../redux/actions/contract'
import CenterChangeFormWidget from '../../../widgets/contractChangeForm/CenterChangeFormWidget'

export default function ContractChangeForm() {
  const [schema, setSchema] = useState()
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState()
  const projectId = sessionStorage.getItem('projectId')
  const contractChangeId = sessionStorage.getItem('contract_change_id')

  useEffect(() => {
    projectId && handleGetSchema(projectId)
  }, [])

  const handleGetSchema = async (projectVersionId) => {
    setIsLoading(true)
    startLoading()

    try {
      const response = await getContractChangeFormPage(projectVersionId, contractChangeId)
      // console.log('response => ', response)
      setSchema(response.model)
    } catch (e) {
      console.log('error', e)
      if (e?.response?.data) {
        setError({
          statusCode: e.response.data.status,
          errorMessage: e.response.data.errors?.message,
        })
      } else {
        setError({})
      }
    }
    doneLoading()
    setIsLoading(false)
  }

  if (error) {
    return (
      <SidebarProposal>
        <ErrorWidget statusCode={error.statusCode} errorMessage={error.errorMessage} />
      </SidebarProposal>
    )
  }

  if (!schema || isLoading) {
    return (
      <SidebarProposal>
        <PanalLoadingTemplate />
      </SidebarProposal>
    )
  }

  return (
    <>
      <SidebarProposal>
        <ContentHeader header={schema?.header} subHeader={schema?.subHeader} />
        {schema && (
          <>
            <CenterChangeFormWidget schema={schema} />
          </>
        )}
        <br />
      </SidebarProposal>
    </>
  )
}
